import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { PEN_7401_FLAG } from '../constants'

export const useTrackPen7401Experiment = () => {
  useEffect(() => {
    trackExperimentViewed(PEN_7401_FLAG)
  }, [])
}
